import { NbDialogService } from '@nebular/theme';
import { OutsideStaffService } from '../../services/outside-staff.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { HelperService } from '../../services/helper.service';
import { LogbookService } from '../../services/logbook.service';
import { FirebaseStorageService } from '../../services/firebase-storage.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {finalize} from 'rxjs/operators';
import { EmployeeService } from '../../employee.service';
import {ExternalStaffService} from '../../services/external-staff.service';
import { StaffOutsideStationModuleComponent } from '../../staff-outside-station/staff-outside-station-module/staff-outside-station-module.component';
import { Ng2ImgMaxService } from 'ng2-img-max';
import {AuthorizationService} from '../../services/authorization.service';
import { AnnualProgramService } from '../../services/annual-program.service';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import { LogbooksAuthorizationComponentComponent } from '../../authorizations/logbooks-authorization-module/logbooks-authorization-component/logbooks-authorization-component.component';
import { NewEmployeeComponent } from '../../new-employee/new-employee.component';
import * as moment from 'moment';
import { ModuleExternalStaffComponent } from '../../external-staff/module-external-staff/module-external-staff.component';


interface Logbook {
  type: any;
  activity_type: string;
  date: any;
  end_date: any;
  responsable: string;
  start_time: string;
  end_time: string;
  external_staff: {
    provider: '',
    responsable: '',
  };
  fields?: any;
}

@Component({
  selector: 'ngx-add-manteinence-logbook',
  templateUrl: './add-manteinence-logbook.component.html',
  styleUrls: ['./add-manteinence-logbook.component.scss'],
})

export class AddManteinenceLogbookComponent implements OnInit {
  @ViewChild(SignaturePad, { static: true }) signaturePad: SignaturePad;

  signaturePadOptions: Object;
  loading: boolean = false;
  @Input() stationId: string;
  @Output() refreshLogbook: EventEmitter<any> = new EventEmitter();
  imageBase64: string = '';

  paramsMtoGeneral = [
    {
      equip: 'Protección auditiva',
      detail: 'Tapones, diademas auditivas, orejeras',
      value: false,
    },
    {
      equip: 'Casco de seguridad',
      detail: 'Cascos de seguridad, cascos de protección con reflejante termoplástico y barbiquejo',
      value: false,
    },
    {
      equip: 'Protección para manos',
      detail: `Guantes de uso general: Algodón, Poliéster, Nylon libre de pelusa, guantes para altas temperaturas, guantes para soldar, guantes de uso pesado, guantes contra quimicos - acidos, solventes - causticos, aplicaciones en frio, guantes anticorte - manejo de vidrio, cuchillas, herramienta de corte, hojas de acero.`,
      value: false,
    },
    {
      equip: 'Protección ocular',
      detail: 'Lentes de seguridad',
      value: false,
    },
    {
      equip: 'Máscara de soldar',
      detail: 'Máscara de mano, máscara de cabeza, máscara fotosensible',
      value: false,
    },
    {
      equip: 'Arnés/Cinturón de seguridad',
      detail: 'Arneses para trabajo en alturas, ascenso y descenso, espacios confinados y suspendido',
      value: false,
    },
    {
      equip: 'Ropa protectora de trabajo',
      detail: `Overol contra choques eléctricos resistente al fuego, protección contra ambientes de alto calor, mandil de nopreno para salpicaduras de químicos. Camisolas de mezclilla, mandil, mangas de mezclilla, vinil, laminadas, overol de gabardina.`,
      value: false,
    },
    {
      equip: 'Otro',
      detail: ``,
      value: false,
    },
  ];
  paramsMtoGeneralAltura = [
    {
      equip: 'Protección auditiva',
      detail: 'Tapones, diademas auditivas, orejeras',
      value: false,
    },
    {
      equip: 'Casco de seguridad',
      detail: 'Cascos de seguridad, cascos de protección con reflejante termoplástico y barbiquejo',
      value: false,
    },
    {
      equip: 'Protección para manos',
      detail: `Guantes de uso general: Algodón, Poliéster, Nylon libre de pelusa, guantes para altas temperaturas, guantes para soldar, guantes de uso pesado, guantes contra quimicos - acidos, solventes - causticos, aplicaciones en frio, guantes anticorte - manejo de vidrio, cuchillas, herramienta de corte, hojas de acero.`,
      value: false,
    },
    {
      equip: 'Protección ocular',
      detail: 'Lentes de seguridad',
      value: false,
    },
    {
      equip: 'Máscara de soldar',
      detail: 'Máscara de mano, máscara de cabeza, máscara fotosensible',
      value: false,
    },
    {
      equip: 'Arnés/Cinturón de seguridad',
      detail: 'Arneses para trabajo en alturas, ascenso y descenso, espacios confinados y suspendido',
      value: false,
    },
    {
      equip: 'Ropa protectora de trabajo',
      detail: `Overol contra choques eléctricos resistente al fuego, protección contra ambientes de alto calor, mandil de nopreno para salpicaduras de químicos. Camisolas de mezclilla, mandil, mangas de mezclilla, vinil, laminadas, overol de gabardina.`,
      value: false,
    },
    {
      equip: 'Otro',
      detail: ``,
      value: false,
    },
  ];

  paramsConfinedSpaces = [
    {
      risk: 'Asfixia',
      value: false,
    },
    {
      risk: 'Incendio o explosión',
      value: false,
    },
    {
      risk: 'Intoxicación',
      value: false,
    },
    {
      risk: 'Ruido',
      value: false,
    },
    {
      risk: 'Iluminación',
      value: false,
    },
    {
      risk: 'Vibración',
      value: false,
    },
    {
      risk: 'Condiciones térmicas elevadas o abatidas',
      value: false,
    },
    {
      risk: 'Riesgos mecánicos, eléctricos o neumáticos',
      value: false,
    },
  ];

  paramsEquipment = [
    {
      equipment: 'Casco contra impactos',
      value: false,
    },
    {
      equipment: 'Goggles',
      value: false,
    },
    {
      equipment: 'Equipo de respiración autónomo',
      value: false,
    },
    {
      equipment: 'Guantes',
      value: false,
    },
    {
      equipment: 'Mangas',
      value: false,
    },
    {
      equipment: 'Ropa contra sustancias peligrosas',
      value: false,
    },
    {
      equipment: 'Traje impermeable',
      value: false,
    },
    {
      equipment: 'Arnés de cuerpo entero y línea de salvamento',
      value: false,
    },
    {
      equipment: 'Calzado contra sustancias químicas',
      value: false,
    },
    {
      equipment: 'Equipo de iluminación',
      value: false,
    },
  ];

  concentrationReadings= [
    {
      name: 'Porcentaje de oxígeno (%)',
      code: 'oxygenPercentage',
      value: '',
    },
    {
      name: 'Gasolina 87 octanos (% límite inferior de inflamabilidad)',
      code: 'gasoline87',
      value: '',
    },
    {
      name: 'Gasolina 91 octanos (% límite inferior de inflamabilidad)',
      code: 'gasoline91',
      value: '',
    },
    {
      name: 'Diesel (% límite inferior de inflamabilidad)',
      code: 'diesel',
      value: '',
    },
  ];

  newLogbook: Logbook = {
    type: 1,
    activity_type: '',
    date: new Date(),
    end_date: new Date(),
    start_time: moment().format('H:mm'),
    end_time: moment().format('H:mm'),
    responsable: '',
    external_staff: {
      provider: '',
      responsable: '',
    },
    fields: {
      description: '',
      element: '',
      typeActivity: '',
      dataTypeActivity: {},
      authorization_id: '',
    },
  };

  typeMaintenance = [
    {
      value: 'mantenimiento_preventivo',
      label: 'Mantenimiento Preventivo',
      checked: false
    },
    {
      value: 'mantenimiento_correctivo',
      label: 'Mantenimiento Correctivo',
      checked: false
    },
    {
      value: 'mantenimiento_predictivo',
      label: 'Mantenimiento Predictivo',
      checked: false
    }
  ]
  employees = [];
  images: Array<any> = [];
  uploads = [];
  uploadPercent: any;
  downloadURLs = [];
  externalStaff = [];
  outsideStaff = [];
  authorizations = [];
  percentage = 0;
  catalog = [];

  constructor(
    private logbookService: LogbookService,
    private employeeService: EmployeeService,
    private externalStaffService: ExternalStaffService,
    private outsideStaffService: OutsideStaffService,
    private helperService: HelperService,
    private firebaseStorageService: FirebaseStorageService,
    private dialogService: NbDialogService,
    private ng2ImgMax: Ng2ImgMaxService,
    private authorizationService: AuthorizationService,
    private annualProgramService: AnnualProgramService,
  ) { }

  async ngOnInit() {
    this.loading = true;
    await Promise.all([
      this.getEmployees(),
      this.getAuthorizations(),
      this.getExternalStaffStation(),
      this.getCatalog()
    ])
    this.loading = false

  }

  async loadImage(event: any) {
    if (!event.target.files.length) return;
    this.loading = true;
    for await (const image of event.target.files) {
      const reader = new FileReader();
      if (image.type.includes("jpeg") || image.type.includes("jpg") || image.type.includes("png")) {
        this.ng2ImgMax.resizeImage(image, 1280, 720).subscribe(
          async (result) => {
            await reader.readAsDataURL(result);
            reader.onload = (e: any) => result.imageBase64 = e.target.result;
            this.images.push(result);
            this.loading = false;
          },
          () => {
            this.loading = false;
            return this.alert('Oops, intenta más tarde', 'error', 'Error al intentar cargar la imagen');
          },
        );
      } else {
        image.imageBase64 = 'https://freeiconshop.com/wp-content/uploads/edd/document-download-flat.png';
        this.images.push(image);
        this.loading = false;
      }

    }
  }

  async getOutsideStaff() {
    this.loading = true;
    const [err, response]: any = await this.outsideStaffService.index(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. Lista personal externo');
    this.outsideStaff = response.data;
    console.error(this.outsideStaff)
  }

  async getExternalStaffStation() {
    const [err, response]: any = await this.externalStaffService.getExternalStaffStation(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista proveedores]', 'error');
    this.externalStaff = response.data;
  }

  async getAuthorizations() {
    const [err, response]: any = await this.authorizationService.index(this.stationId);
    if (err) return this.alert('Oops,', 'error', 'Intenta más tarde [Error. Lista de Autorizaciones]');
    this.authorizations = response.data;
  }

  async getEmployees () {
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    this.employees = result.data;
  }

  formatedTypeMaintenance () {
    const response = []
    for (const type of this.typeMaintenance) if (type.checked) response.push(type.value)
    return response.join(',');
  }

  validateForm() {
    this.store()
  }

  async store() {
    if (this.newLogbook.fields.typeActivity === 'trabajo_mantenimiento_general') this.newLogbook.fields.dataTypeActivity.paramsMtoGeneral = this.paramsMtoGeneral;
    if (this.newLogbook.fields.typeActivity === 'trabajo_altura') this.newLogbook.fields.dataTypeActivity.paramsMtoGeneralAltura = this.paramsMtoGeneralAltura;
    if (this.newLogbook.fields.typeActivity === 'espacios_confinados') {
      this.newLogbook.fields.dataTypeActivity.paramsConfinedSpaces = this.paramsConfinedSpaces;
      this.newLogbook.fields.dataTypeActivity.paramsEquipment = this.paramsEquipment;
      this.newLogbook.fields.dataTypeActivity.concentrationReadings = this.concentrationReadings;
      this.newLogbook.responsable = this.newLogbook.fields.dataTypeActivity.worksResponsable.toString() ;
    }
    const validDataHasEmptyFields = Object.keys(this.newLogbook).includes('');
    const validFieldsHasEmptyFields = Object.keys(this.newLogbook.fields).includes('');
    if (validDataHasEmptyFields || validFieldsHasEmptyFields) return this.alert('Ingresa todos los datos necesiarios', 'error');
    this.loading = true;
    this.newLogbook.fields.typeMaintenance = this.formatedTypeMaintenance()
    const [error, result]: any = await this.logbookService.store(this.stationId, this.newLogbook);
    if (error) {
      const errorMessage = '<p>' + error.error.error.join('<br>') + '</p>';
      this.loading = false;
      return this.alert('Oops, ocurrió algo', 'error', '', errorMessage);
    }
    const logbookId = result.data.id;
    if (!this.images.length) {
      this.loading = false;
      this.refreshLogbook.emit(true);
      this.logbookService.exitCreateLogbook()
      return this.alert('Bitácora creada con éxito', 'success');
    }
    await this.firebaseStorageService.setPath('images/logbooks');
    this.uploads = [];
    this.downloadURLs = [];
    console.log(this.images);

    for await (const [index, file] of this.images.entries()){
      const extension = file.name.split('.')[1];
      const filename = `${logbookId}_${index}.${extension}`;
      const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
      const task = this.firebaseStorageService.taskCloudStorage(filename, file);

      // observe percentage changes
      this.uploadPercent = task.percentageChanges();

      // get notified when the download URL is available
      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(async (url) => {
            this.downloadURLs = this.downloadURLs.concat([url]);
            if (this.images.length === this.downloadURLs.length) {
              const firstURL = this.downloadURLs[0];
              this.downloadURLs.shift();
              const [err] = await this.logbookService.updateUrlImage(logbookId, firstURL, this.downloadURLs);
              if (err) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
              this.refreshLogbook.emit(true);
              this.logbookService.exitCreateLogbook()
              this.alert('Bitácora creada con éxito', 'success');
              this.loading = false;
            }
          });
        }),
      ).subscribe();
    }
  }

  async delete(index: number) {
    this.images.splice(index, 1);
  }

  openModalOutsideStaff(isEdit = false) {
    this.dialogService.open(StaffOutsideStationModuleComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => modified ? this.getOutsideStaff() : console.error('no modificaron nada'));
  }

  openModal(isEdit = false) {
    this.dialogService.open(LogbooksAuthorizationComponentComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => modified ? this.getAuthorizations() : console.error('no modificaron nada'));
  }

  openNewEmployee() {
    this.dialogService.open(NewEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  async changeTypeActivity() {
    this.newLogbook.fields.dataTypeActivity = {};
    if (this.newLogbook.fields.typeActivity === 'trabajo_altura') {
      this.newLogbook.fields.dataTypeActivity = { placeWork: '', levelDangerous: '', typeWork: '', outsideStaff: [], authorized_person: '' };
    }
    if (this.newLogbook.fields.typeActivity === 'trabajo_caliente') {
      this.newLogbook.fields.dataTypeActivity = { levelDangerous: '', typeWork: '', outsideStaff: [], authorized_person: '' };
    }
    if (this.newLogbook.fields.typeActivity === 'trabajo_mantenimiento_general') {
      this.newLogbook.fields.dataTypeActivity = { outsideStaff: [], authorized_person: '' };
    }
    if (this.newLogbook.fields.typeActivity === 'espacios_confinados') {
      this.newLogbook.fields.dataTypeActivity = { placeWork: '', authorized_person: '' };
    }
    if (this.newLogbook.fields.typeActivity !== '') this.getOutsideStaff();
  }

  async validateExternalStaff() {
    this.newLogbook.external_staff = {
      provider: '',
      responsable: '',
    };
    if (this.newLogbook.responsable !== 'otro') return;
  }

  async getCatalog () {
    const [error, response] = await this.annualProgramService.getAnnualProgramNewCatalog();
    if (error) return console.error(error)
    this.catalog = response.data
  }

  searchElements = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.catalog['elements'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
    )

  searchNames = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.catalog['names'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
    )

  searchActivities = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.catalog['activities'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
    )

  searchServices = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.catalog['types'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
    )

    openModalNewExternalStaff(isEdit: boolean = false) {
      this.dialogService.open(ModuleExternalStaffComponent, {
        hasScroll: true,
        context: {
          externalStaff: {
            name: '',
            rfc: '',
            address: '',
            phone: '',
          },
          stationId: this.stationId,
          isEdit,
        },
      }).onClose.subscribe((modified: boolean) => modified ? this.getExternalStaffStation() : console.error('no modificaron'));
    }

  async alert(title: string = 'asdasd', icon: SweetAlertIcon = 'success', text: string = '', html: string = '') {
    await Swal.fire({ icon, title, text, html });
  }
}
